import React, { useState, createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";


export const AuthContext = createContext({
  isLoggedIn: false,
  user: null,
  login: () => {},
  logout: () => {},
  setUser: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  let navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // 앱 시작 시 서버 세션 확인
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch('/request/check-session', { credentials: 'include' });
        const data = response.ok ? await response.json() : {};
        if (!data.success || !data.user) {
          if (response.status === 401 && window.top !== window.self) {
            window.parent.postMessage({ type: 'CONNECTED_APP_SESSION_EXPIRED' }, '*');
          }
          // A direct visit has no sidebar handoff. Reuse the existing AntsTalk
          // session once, but never redirect an embedded or public share page.
          if (response.status === 401 && window.top === window.self &&
              !window.location.pathname.startsWith('/chart/') &&
              !sessionStorage.getItem('gantt_sso_attempted')) {
            sessionStorage.setItem('gantt_sso_attempted', '1');
            const login = new URL('https://talk.antsnest.co.kr/popup/login');
            login.searchParams.set('parentOrigin', window.location.origin);
            login.searchParams.set('redirect', window.location.href);
            window.location.replace(login.toString());
            return;
          }
          throw new Error('No verified session');
        }
        sessionStorage.removeItem('gantt_sso_attempted');
        setIsLoggedIn(true); setUser(data.user); sessionStorage.setItem('user', JSON.stringify(data.user));
      } catch (_) {
        sessionStorage.removeItem('user'); localStorage.removeItem('user');
        setIsLoggedIn(false); setUser(null);
      } finally { setIsLoading(false); }
    };
    checkSession();
  }, []);

  const login = async (userData) => {
    // console.log(`## login start ##`);
    sessionStorage.setItem("user", JSON.stringify(userData));
    setIsLoggedIn(true);
    setUser(userData);
    navigate("/");
    // console.log(`## login end ##`);
  };

  const logout = async () => {
    const response = await fetch('/request/logout', { method: 'POST', credentials: 'include' });
    if (!response.ok) throw new Error('로그아웃에 실패했습니다. 다시 시도해 주세요.');
    // console.log(`## logout start ##`);
    const storedUser = await JSON.parse(sessionStorage.getItem("user"));
    //await delSessionFunc(storedUser.phone_number);
    sessionStorage.removeItem("user");

    setIsLoggedIn(false);
    setUser(null);
    // console.log(`## logout end ##`);
    navigate("/"); // 로그아웃 후 로그인 페이지로 리디렉션
  };
  const updateUser = (updatedUserData) => {
    setUser(updatedUserData);
  };

  // 로딩 중일 때는 빈 화면 또는 로딩 표시
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider
      value={{ isLoggedIn, user, login, logout, setIsLoggedIn, setUser, updateUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};
